import React from "react";

/**
 * Logo wordmark. Inline SVG so type color follows the parent text color
 * via `currentColor`. Public/wordmark.svg holds the same mark as a file
 * for favicons and external embeds.
 */
export default function Wordmark({ size = "md", inverse = false, style, ...rest }) {
    const cls =
        size === "sm" ? "logo-img-sm" : size === "lg" ? "logo-img-lg" : "logo-img-md";
    const color = inverse ? "var(--bt-paper)" : "var(--bt-ink)";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 800 280"
            role="img"
            aria-label="Brass Tacks Brief"
            className={cls}
            style={{ color, display: "block", ...(style || {}) }}
            {...rest}
        >
            <title>Brass Tacks Brief</title>
            <line
                x1="60"
                y1="22"
                x2="740"
                y2="22"
                stroke="currentColor"
                strokeWidth="1.25"
                strokeLinecap="square"
            />
            <text
                x="400"
                y="170"
                textAnchor="middle"
                fill="currentColor"
                style={{
                    fontFamily:
                        "Fraunces, 'Bodoni Moda', 'Times New Roman', Georgia, serif",
                    fontWeight: 900,
                    fontSize: "152px",
                    fontVariationSettings: '"opsz" 144, "WONK" 1, "SOFT" 0',
                    letterSpacing: "-0.02em",
                }}
            >
                BRASS TACKS
            </text>
            <text
                x="414"
                y="232"
                textAnchor="middle"
                fill="currentColor"
                style={{
                    fontFamily:
                        "Newsreader, Spectral, 'Times New Roman', Georgia, serif",
                    fontWeight: 600,
                    fontSize: "56px",
                    fontVariationSettings: '"opsz" 36',
                    letterSpacing: "0.50em",
                }}
            >
                BRIEF
            </text>
            <line
                x1="60"
                y1="258"
                x2="740"
                y2="258"
                stroke="currentColor"
                strokeWidth="1.25"
                strokeLinecap="square"
            />
        </svg>
    );
}
